import React, {ChangeEvent, useEffect, useState} from "react";
import {Input} from "../../../ui-components/Input/Input";
import {ValidationErrorText} from "../../../ui-components/ValidationErrorText/ValidationErrorText";

interface StateInputProps {
    state: string;
    onSetState: (state: string) => void;
    onSetIsStateValid: (isStateValid: boolean) => void;
}

export const StateInput: React.FunctionComponent<StateInputProps> = (props) => {
    const [errors, setErrors] = useState<string[]>([]);
    const [isValid, setIsValid] = useState<boolean>(true);
    const requiredStateError = 'State is a required field.';
    const [isSubmitted, setIsSubmitted] = useState<boolean>(false);

    useEffect(() => {
        props.onSetIsStateValid(isValid);
    }, [isValid])

    const onChange = (event: ChangeEvent) => {
        props.onSetState((event.target as HTMLInputElement).value);
        validateState();
    }

    const onKeyUp = (event: React.KeyboardEvent<HTMLInputElement>) => {
        validateState();
    }

    const validateState = () => {
        let errorsTemp: string[] = [];
        if (props.state === '') {
            errorsTemp.push(requiredStateError);
        }
        setErrors(errorsTemp);
        setIsValid(errorsTemp.length === 0);
    }

    const onBlur = (event: React.FocusEvent<HTMLInputElement>) => {
        setIsSubmitted(true);
        validateState();
    }

    return <div>
        <Input isValid={isValid} type='text' required={true} value={props.state} onChange={onChange}
               onKeyUp={onKeyUp} onBlur={onBlur}/>
        {isSubmitted && errors.map((error: string) => {
            return <ValidationErrorText key={error} text={error}/>
        })}
    </div>
}
